import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";
import { TableConfigState } from "@/types/tableConfig";

import { tableConfigApi } from "./tableConfig.api";

const initialState: TableConfigState = {
	data: null,
};

export const tableConfigSlice = createSlice({
	name: "tableConfig",
	initialState,
	reducers: {
		clearTableConfig: (state) => {
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			tableConfigApi.endpoints.getTableConfig.matchFulfilled,
			(state, { payload }) => {
				state.data = payload;
			}
		);
		builder.addMatcher(
			tableConfigApi.endpoints.updateTableConfig.matchFulfilled,
			(state, { payload }) => {
				state.data = payload;
			}
		);
	},
});

export const { clearTableConfig } = tableConfigSlice.actions;
export const tableConfigReducer = tableConfigSlice.reducer;
export const tableConfigSelector = (state: RootState) => state[tableConfigSlice.name];
